// AI generated
// Shared literals for the React-Flow editor extension.

/** Height a new flow element is persisted with; also its min-height. */
export const DEFAULT_FLOW_HEIGHT = 500
export const MAX_FLOW_HEIGHT = 5000

export const CANVAS_BACKGROUND = '#F7F9FB'
export const DEFAULT_NODE_BACKGROUND = '#ffffff'
export const DEFAULT_BORDER_COLOR = '#a8a29e'

/** Size a new group node is created with. */
export const GROUP_SIZE = { width: 400, height: 500 } as const

export const SAVE_DEBOUNCE_MS = 50
export const HEIGHT_SAVE_DEBOUNCE_MS = 300

/** Snap threshold in px for the helper lines, and their stroke colour. */
export const HELPER_LINE_DISTANCE = 5
export const HELPER_LINE_COLOR = '#0041d0'
